(function (r, e, o) {
  var w = window,
    d = document,
    t,
    s,
    x;
  w.tfcapi = t =
    w.tfcapi ||
    function () {
      t.q = t.q || [];
      t.q.push(arguments);
    };
  t('init', { storeKey: r, environment: e, ...o });
  x = d.getElementsByTagName('script')[0];
  s = d.createElement('script');
  s.type = 'text/javascript';
  s.async = true;
  s.crossorigin = 'anonymous';
  s.src = 'https://cdn.truefitcorp.com/fitrec/global/js/tf-integration.js?storeKey=' + r;
  x.parentNode.insertBefore(s, x);
})('sqe', 'prod');

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('DOMContentLoaded', () => {
    new MutationObserver(() => tfcapi('calculate')).observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

function observeCartChanges() {
  const cartObserver = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
      const isCartChangeRequest = /\/cart\/add/.test(entry.name);
      if (isValidRequestType && isCartChangeRequest) {
        tfcapi('getToken', async (token) => {
          if (!token) {
            await fetch('https://setup.truefit.com/api/public/track/', {
              method: 'POST',
              keepalive: true,
              body: JSON.stringify({
                additionalInfo: {
                  shop: window.Shopify.shop,
                },
                type: 'emptyTfcToken',
                level: 'info',
                timestamp: new Date().toISOString(),
              }),
              headers: {
                'Content-Type': 'application/json',
              },
            });
            return;
          }
          const formData = new FormData();
          formData.append('attributes[_tfcToken]', token);
          await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            keepalive: true,
            body: formData,
          });
        });
      }
    });
  });
  cartObserver.observe({ entryTypes: ['resource'] });
}
observeCartChanges();
